<template>
    <v-data-table
    :headers="headers"
  :items="data"
  :search="search"
  item-key="id" 
  :sort-by="sortBy"
  :sort-desc="sortDesc"
  @update:sortBy="updateSortBy"
  @update:sortDesc="updateSortDesc"
    >
      <template v-slot:item.actions="{ item }">
        <v-icon @click="editItem(item)">mdi-pencil</v-icon>
        <edit-Bonus-modal
      :dialog-value="editDialog"
      :edited-item="editedItem"
      @save-edited-item="saveEditedItem"
      @close-modal="closeEditDialog"
    ></edit-Bonus-modal>
      </template>
      <template v-slot:item.user="{ item }">
        {{ item.user.username || 'N/A' }}
      </template>
    </v-data-table>
  </template>
  
  <script>
 import editBonusModal from './edit-bonus.vue'
  export default {
    props: {
      data: Array,
    },
    data() {
      return {
        headers: [
          { text: 'First Name', value: 'user.profile.firstname' },
          { text: 'Last Name', value: 'user.profile.lastname' },
          { text: 'Amount', value: 'amount' },
          { text: 'Trade Type', value: 'tradeType' },
          { text: 'Created', value: 'created' },
          { text: 'Status', value: 'status' },
          { text: 'Actions', value: 'actions', sortable: false },
        ],
        search: '',
        sortBy: 'created',
        sortDesc: false,
        editDialog: false,
        editedItem: {},
      };
    },
    components:{
        editBonusModal
    },
    methods: {
      updateSortBy(value) {
        this.sortBy = value;
      },
      updateSortDesc(value) {
        this.sortDesc = value;
      },
      editItem(item) {
        this.editDialog = false;
        console.log(this.editDialog);
        console.log('Edit item:', item);
        this.editDialog = true;
      },
      closeEditDialog() {
      // Close the edit dialog and reset the edited item
      this.editDialog = false;
      this.editedItem = {};
    },
    saveEditedItem(editedItem) {
      // Save the edited item and update your data
      // Implement your logic here to update the data with the edited item
      console.log('Saving edited item:', editedItem);

      // Close the edit dialog
      this.closeEditDialog();
    }
    },
  };
  </script>
  
  <style scoped>
  /* Add any custom styles here */
  </style>
  